// Central site data — business info, links, service details.

export const SITE = {
  brand: "Skin Refinery by Lacretia",
  owner: "LaCretia Wheeler",
  title: "Missouri Licensed Esthetician",
  address: "3897 N 20th St. Unit 1, Ozark, MO",
  phone: null, // not provided yet
  email: "info@skinrefinerybylacretia.com",
  bookingUrl: "https://skin-refinery-by-lacretia.comb.works",
  instagram: "https://www.instagram.com/skinrefinery.417",
  tiktok: "https://www.tiktok.com/@skinrefinery.417",
  facebook: null,
};

export const SERVICES = [
  {
    id: "korean-lash-lift",
    title: "Korean Lash Lift",
    tagline: "Naturally lifted lashes with a healthier approach.",
    image: "/images/lash-main.jpg",
    imageAlt: "Close-up of a stunning Korean lash lift result — blue eye with natural, lifted lashes",
    portfolio: [
      { src: "/images/lash-main.jpg", alt: "Blue-eye Korean lash lift close-up" },
      { src: "/images/portfolio/lash-1.jpg", alt: "Korean lash lift close-up — green eye" },
      { src: "/images/portfolio/brow-4.jpg", alt: "Single-eye lash lift result on freckled skin" },
      { src: "/images/portfolio/lash-2.jpg", alt: "Client showing off her Korean lash lift results" },
      { src: "/images/portfolio/brow-7.jpg", alt: "Lifted lashes shown from both eyes" },
      { src: "/images/portfolio/lash-4.jpg", alt: "Korean lash lift before and after comparison" },
      { src: "/images/portfolio/lash-3.jpg", alt: "Delicate lash lift result close-up" },
    ],
    intro:
      "A Korean lash lift is an advanced technique that enhances your natural lashes by lifting and shaping them from the root for a longer, more elegant appearance—without extensions. Using gentler formulas and customized processing times, this treatment prioritizes the health of your natural lashes while delivering beautifully lifted results that last 6–8 weeks.",
    whyTitle: "Why Choose a Korean Lash Lift?",
    whyIntro:
      "Unlike traditional lash lifts that often use stronger formulas and standardized processing times, my Korean lash lift technique focuses on the integrity of your natural lashes.",
    benefits: [
      "Gentler, lower-pH formulas",
      "Customized processing for every lash type",
      "Less risk of over-processing",
      "Softer, healthier-looking results",
      "Beautiful lift that grows out naturally",
      "Perfect for straight, downward-growing, or difficult-to-lift lashes",
    ],
    faqs: [
      {
        q: "How long does a Korean lash lift last?",
        a: "Most clients enjoy beautifully lifted lashes for 6–8 weeks, depending on their natural lash growth cycle.",
      },
      {
        q: "Does it damage my natural lashes?",
        a: "When performed correctly with quality products and proper processing, a Korean lash lift is designed to maintain the health of your natural lashes while enhancing their appearance.",
      },
      {
        q: "Can I wear mascara?",
        a: "Yes! Many clients find they no longer need mascara, but you can absolutely wear it if you’d like even more definition.",
      },
      {
        q: "Is there any downtime?",
        a: "No. You can return to your normal routine immediately. For best results, avoid getting your lashes wet, using steam, or applying eye makeup for the first 24 hours.",
      },
      {
        q: "Who is a good candidate?",
        a: "Anyone looking to enhance their natural lashes without extensions. It’s especially great for straight, downward-facing, or difficult-to-curl lashes.",
      },
      {
        q: "Can I still get a lash lift if I have short lashes?",
        a: "Absolutely! While longer lashes create a more dramatic effect, Korean lash lifts can beautifully enhance shorter lashes as well by maximizing your natural lift.",
      },
    ],
  },
  {
    id: "brow-lamination",
    title: "Brow Lamination & Tint",
    tagline: "Fuller, fluffier brows without permanent makeup.",
    image: "/images/brow-main.jpg",
    imageAlt: "Sculpted, laminated brow paired with a natural Korean lash lift by Skin Refinery",
    portfolio: [
      { src: "/images/portfolio/brow-1.webp", alt: "Full-face view of a laminated brow on dark skin" },
      { src: "/images/portfolio/brow-2.jpg", alt: "Brow lamination before and after — freckled skin" },
      { src: "/images/portfolio/brow-6.jpg", alt: "Brow lamination before and after with lash extensions" },
      { src: "/images/portfolio/brow-3.jpg", alt: "Soft, fluffy brow lamination detail" },
    ],
    intro:
      "Brow lamination smooths and redirects your natural brow hairs into a fuller, more defined shape that lasts for weeks. Whether you love a soft, natural look or a bold, brushed-up style, each treatment is customized to complement your facial features and enhance your natural brows.",
    whyTitle: "Why Choose Brow Lamination?",
    whyIntro:
      "Every set is customized to your face and features, using professional formulas that keep your brows soft and conditioned.",
    benefits: [
      "Customized shape and finish for every client",
      "Professional-grade lamination products",
      "Optional brow tint for extra definition",
      "Soft, styled brows that last 6–8 weeks",
      "Ideal for unruly, sparse, or downward brows",
    ],
    faqs: [
      {
        q: "How long does brow lamination last?",
        a: "Most clients enjoy their results for 6–8 weeks, depending on their natural hair growth cycle and aftercare.",
      },
      {
        q: "Does brow lamination damage my brows?",
        a: "When performed correctly with professional products and proper processing, brow lamination is designed to maintain the health of your natural brow hairs while enhancing their appearance.",
      },
      {
        q: "Will my brows stay brushed up all the time?",
        a: "Not necessarily. Your brows can be styled in different ways each day, whether you prefer a soft, natural finish or a fuller, fluffy look.",
      },
      {
        q: "Is there any downtime?",
        a: "No. For the best results, avoid getting your brows wet, exercising, using steam, or applying brow makeup for the first 24 hours.",
      },
      {
        q: "Can I get my brows tinted at the same appointment?",
        a: "Yes! Brow tinting pairs perfectly with brow lamination to create even more definition and enhance the overall result.",
      },
      {
        q: "Who is a good candidate?",
        a: "Brow lamination is ideal for anyone with unruly, sparse, asymmetrical, or downward-growing brows who wants a fuller, more polished appearance without permanent makeup.",
      },
    ],
  },
  {
    id: "skin-treatments",
    title: "Skin Treatments",
    tagline: "Personalized skincare designed to refine your natural beauty.",
    image: "/images/skin-treatment.jpg",
    imageAlt:
      "Client relaxing during a moody, candle-lit facial treatment at Skin Refinery",
    portfolio: [
      { src: "/images/skin-treatment.jpg", alt: "Facial treatment in the Skin Refinery studio" },
      { src: "/images/portfolio/skin-2.jpg", alt: "Client mid-facial, wrapped in headband, moody studio lighting" },
      { src: "/images/portfolio/skin-1.jpg", alt: "Bright, healthy post-facial glow" },
    ],
    intro:
      "Healthy, glowing skin starts with treatments tailored to your unique skin — not a one-size-fits-all approach. Whether you’re looking to address acne, pigmentation, texture, signs of aging, or simply maintain a healthy complexion, every treatment is customized using professional skincare and advanced techniques to help you achieve lasting results.",
    whyTitle: "Why Choose Skin Refinery?",
    whyIntro: "Your skin is unique, and your treatment should be too.",
    benefits: [
      "Customized treatments based on your skin goals",
      "Professional-grade skincare products",
      "Korean-inspired techniques focused on skin health",
      "Advanced options for acne, pigmentation, texture, and aging",
      "Education and personalized home care recommendations",
      "Results-driven care in a relaxing environment",
    ],
    faqs: [
      {
        q: "Which facial is right for me?",
        a: "Don’t worry if you’re unsure! We’ll discuss your concerns during your appointment and choose the treatment that’s best suited for your skin.",
      },
      {
        q: "How often should I get a facial?",
        a: "For general maintenance, every 4–6 weeks is ideal. If you’re targeting specific concerns like acne or pigmentation, I may recommend a customized treatment plan.",
      },
      {
        q: "Will I see results after one treatment?",
        a: "Many clients notice healthier, more radiant skin after their first visit. However, long-term concerns such as acne, discoloration, and aging typically require a series of treatments combined with a consistent home care routine.",
      },
      {
        q: "Do I need to use professional skincare?",
        a: "While it’s not required, professional skincare can significantly improve and maintain your results. I’ll only recommend products I truly believe will benefit your skin.",
      },
      {
        q: "Is there any downtime?",
        a: "Most facials have little to no downtime. Some advanced treatments may cause temporary redness or peeling, and I’ll always review aftercare with you before you leave.",
      },
    ],
  },
];
